import { render, staticRenderFns } from "./OcorrenciaManage.vue?vue&type=template&id=354698e0&scoped=true"
import script from "./OcorrenciaManage.vue?vue&type=script&lang=js"
export * from "./OcorrenciaManage.vue?vue&type=script&lang=js"
import style0 from "./OcorrenciaManage.vue?vue&type=style&index=0&id=354698e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354698e0",
  null
  
)

export default component.exports